// +----------------------------------------------------------------------
// | AI Memory 接口（Phase 5）
// | 记忆是「AI 眼里的我」，用户必须能看、能改、能删
// +----------------------------------------------------------------------
import request from '../lib/request';

/**
 * 我的记忆列表
 * @param {{type?:string, page?:number, page_size?:number}} params
 */
export function listMemories(params) {
  return request.get('/memories', { params });
}

/**
 * 手动加一条记忆
 * @param {{content:string, type?:string}} data
 */
export function addMemory(data) {
  return request.post('/memories', data);
}

/**
 * 修正记忆内容
 * @param {number} id
 * @param {{content:string}} data
 */
export function updateMemory(id, data) {
  return request.put(`/memories/${id}`, data);
}

/** 删除记忆 */
export function removeMemory(id) {
  return request.delete(`/memories/${id}`);
}

/** 清空全部记忆 */
export function clearMemories() {
  return request.delete('/memories');
}
